import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaEnvelope, FaPhone, FaSpinner, FaCheckCircle } from 'react-icons/fa';
import { API_URL } from '../config/api';


const Footer = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleSubscribe = async () => {
        // Validation basique de l'email
        if (!email || !email.includes('@')) {
            setError('Veuillez entrer une adresse email valide');
            setTimeout(() => setError(null), 3000);
            return;
        }

        setIsSubmitting(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetch(`${API_URL}/newsletter/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    source: 'footer'
                })
            });

            const data = await response.json();

            if (response.ok) {
                setIsSubmitting(false);
                setSuccess(true);
                setEmail('');
                
                // Masquer le message de succès après 5 secondes
                setTimeout(() => {
                    setSuccess(false);
                }, 5000);
            } else {
                // Gestion des erreurs de validation
                if (data.errors && data.errors.email) {
                    throw new Error(data.errors.email[0]);
                } else if (data.message) {
                    throw new Error(data.message);
                } else {
                    throw new Error('Erreur lors de l\'inscription');
                }
            }
        } catch (err) {
            console.error('Erreur:', err);
            setError(err.message || 'Une erreur est survenue. Veuillez réessayer.');
            setIsSubmitting(false);
            
            // Masquer le message d'erreur après 5 secondes
            setTimeout(() => {
                setError(null);
            }, 5000);
        }
    };

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        .footer-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          animation: footerSlideUp 0.6s ease-out;
        }

        @keyframes footerSlideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .footer {
          background: #198754;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .footer-top {
          max-width: 1280px;
          margin: 0 auto;
          padding: 80px 24px 60px;
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr 1.2fr;
          gap: 60px;
        }

        .footer-column {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .footer-logo-container {
          display: flex;
          flex-direction: column;
          gap: 24px;
          animation: fadeInUp 0.8s ease-out;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 8px;
        }

        .footer-logo-icon {
          width: 180px;
          height: 80px;
          background: white;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
        }

        .footer-logo-icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
        }

        .footer-description {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          line-height: 1.7;
          max-width: 320px;
        }

        .footer-tagline {
          color: rgba(255, 255, 255, 0.9);
          font-size: 13px;
          font-style: italic;
          margin-top: 8px;
        }

        .footer-social {
          display: flex;
          gap: 12px;
          margin-top: 8px;
        }

        .social-link {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          font-size: 18px;
          transition: all 0.3s ease;
        }

        .social-link:hover {
          background: white;
          color: #198754;
          border-color: white;
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(255, 255, 255, 0.3);
        }

        .footer-title {
          font-size: 16px;
          font-weight: 700;
          color: #ffc107;
          margin-bottom: 4px;
          letter-spacing: -0.3px;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .footer-link {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .footer-link:hover {
          color: #ffc107;
          transform: translateX(4px);
        }

        .footer-link::before {
          content: '→';
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .footer-link:hover::before {
          opacity: 1;
        }

        /* Newsletter Section - Desktop only */
        .footer-newsletter-section {
          max-width: 880px;
          margin: 0 auto;
          padding: 0 24px 40px;
          animation: fadeInUp 1s ease-out 0.2s both;
          margin-top: -180px;
          margin-right: 160px;   
        }

        .footer-newsletter {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 40px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
        }

        .newsletter-content {
          flex: 1;
        }

        .newsletter-title {
          font-size: 24px;
          font-weight: 700;
          color: white;
          margin-bottom: 8px;
        }

        .newsletter-text {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 1.6;
        }

        /* Messages pour la newsletter */
        .newsletter-message {
          padding: 12px 16px;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          margin-top: 12px;
          animation: slideInDown 0.4s ease-out;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        @keyframes slideInDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .newsletter-success {
          background: rgba(25, 135, 84, 0.2);
          border: 2px solid rgba(255, 255, 255, 0.4);
          color: white;
        }

        .newsletter-error {
          background: rgba(220, 53, 69, 0.2);
          border: 2px solid rgba(255, 255, 255, 0.4);
          color: white;
        }

        .newsletter-form {
          display: flex;
          gap: 12px;
          flex: 1;
          max-width: 500px;
          flex-direction: column;
        }

        .newsletter-form-inputs {
          display: flex;
          gap: 12px;
        }

        .newsletter-input {
          flex: 1;
          padding: 14px 20px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 10px;
          font-size: 14px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.95);
          color: #198754;
        }

        .newsletter-input::placeholder {
          color: rgba(25, 135, 84, 0.6);
        }

        .newsletter-input:focus {
          outline: none;
          border-color: white;
          background: white;
          box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
        }

        .newsletter-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .newsletter-button {
          padding: 14px 32px;
          background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
          white-space: nowrap;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .newsletter-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
        }

        .newsletter-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          line-height: 1.6;
        }

        .contact-icon {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 16px;
          color: white;
        }

        .contact-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .contact-label {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          text-transform: uppercase;
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        .contact-value {
          color: white;
          font-weight: 500;
        }

        .contact-value a {
          color: inherit;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-value a:hover {
          color: #ffc107;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(0, 0, 0, 0.15);
        }

        .footer-bottom-content {
          max-width: 1280px;
          margin: 0 auto;
          padding: 32px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .footer-copyright {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .copyright-text {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
        }

        .copyright-countries {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
          font-weight: 500;
        }

        .footer-legal {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
        }

        .legal-link {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .legal-link:hover {
          color: white;
        }

        .legal-divider {
          color: rgba(255, 255, 255, 0.4);
        }

       
        @media (max-width: 1024px) {
          .footer-top {
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
            padding: 60px 24px 50px;
          }

          .footer-column:first-child {
            grid-column: 1 / -1;
            max-width: 100%;
          }

          .footer-newsletter-section {
            margin-top: -140px;
            margin-right: 80px;
            max-width: 700px;
          }

          .footer-newsletter {
            flex-direction: column;
            padding: 32px;
            gap: 24px;
          }

          .newsletter-form {
            max-width: 100%;
          }

          .footer-description {
            max-width: 100%;
          }
        }

        /* ============================================
           RESPONSIVE STYLES - MOBILE
           ============================================ */
        @media (max-width: 768px) {
          /* Masquer la newsletter sur mobile */
          .footer-newsletter-section {
            display: none;
          }

          .footer-top {
            grid-template-columns: 1fr;
            gap: 40px;
            padding: 40px 20px 30px;
          }

          .footer-column:first-child {
            grid-column: 1;
            text-align: center;
            align-items: center;
          }

          .footer-logo-container {
            align-items: center;
          }

          .footer-brand {
            justify-content: center;
          }

          .footer-logo-icon {
            width: 140px;
            height: 65px;
          }

          .footer-description {
            text-align: center;
            font-size: 13px;
            max-width: 100%;
          }

          .footer-tagline {
            text-align: center;
            font-size: 12px;
          }

          .footer-social {
            justify-content: center;
            margin-top: 12px;
          }

          /* Colonnes de liens */
          .footer-column {
            gap: 16px;
          }

          .footer-title {
            font-size: 15px;
            text-align: left;
            padding-bottom: 4px;
            border-bottom: 2px solid rgba(255, 193, 7, 0.3);
          }

          .footer-links {
            gap: 10px;
          }

          .footer-link {
            font-size: 13px;
            padding: 4px 0;
          }

          .footer-link::before {
            content: '';
          }

          .footer-link:hover::before {
            opacity: 0;
          }

          /* Section Contact - Optimisée pour mobile */
          .footer-contact {
            gap: 12px;
          }

          .contact-item {
            background: rgba(255, 255, 255, 0.05);
            padding: 12px;
            border-radius: 10px;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          .contact-icon {
            width: 32px;
            height: 32px;
            font-size: 14px;
          }

          .contact-label {
            font-size: 11px;
          }

          .contact-value {
            font-size: 13px;
          }

          /* Footer Bottom */
          .footer-bottom-content {
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 24px 20px;
            gap: 16px;
          }

          .footer-copyright {
            align-items: center;
            gap: 6px;
          }

          .copyright-text {
            font-size: 12px;
          }

          .copyright-countries {
            font-size: 11px;
            line-height: 1.5;
          }

          .footer-legal {
            flex-direction: column;
            gap: 8px;
            align-items: center;
          }

          .legal-link {
            font-size: 12px;
          }

          .legal-divider {
            display: none;
          }
        }

        /* ============================================
           RESPONSIVE STYLES - SMALL MOBILE
           ============================================ */
        @media (max-width: 480px) {
          .footer-top {
            padding: 30px 16px 24px;
            gap: 32px;
          }

          .footer-logo-icon {
            width: 120px;
            height: 56px;
          }

          .footer-description {
            font-size: 12px;
            line-height: 1.6;
          }

          .footer-tagline {
            font-size: 11px;
          }

          .social-link {
            width: 36px;
            height: 36px;
            font-size: 16px;
          }

          .footer-title {
            font-size: 14px;
          }

          .footer-link {
            font-size: 12px;
          }

          .contact-item {
            padding: 10px;
          }

          .contact-icon {
            width: 28px;
            height: 28px;
            font-size: 13px;
          }

          .contact-value {
            font-size: 12px;
          }

          .footer-bottom-content {
            padding: 20px 16px;
          }

          .copyright-text {
            font-size: 11px;
          }

          .copyright-countries {
            font-size: 10px;
          }

          .legal-link {
            font-size: 11px;
          }
        }
      `}</style>

            <div className="footer-wrapper">
                <footer className="footer">
                    <div className="footer-top">
                        {/* Column 1 - Brand */}
                        <div className="footer-column">
                            <div className="footer-logo-container">
                                <div className="footer-brand">
                                    <div className="footer-logo-icon">
                                        <img src="../assets/images/logo.png" alt="CINEF Logo" />
                                    </div>
                                </div>
                                <p className="footer-description">
                                    Votre destination pour une formation professionnelle continue de qualité.
                                    Depuis 2010, nous aidons les entreprises et les professionnels à développer
                                    leurs compétences.
                                </p>
                                <p className="footer-tagline">
                                    Excellence · Innovation · Croissance
                                </p>
                            </div>
                            <div className="footer-social">
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                                    <FaFacebookF />
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                                    <FaTwitter />
                                </a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                                    <FaLinkedinIn />
                                </a>
                                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                                    <FaYoutube />
                                </a>
                            </div>
                        </div>

                        {/* Column 2 - Quick Links */}
                        <div className="footer-column">
                            <h3 className="footer-title">Liens Rapides</h3>
                            <div className="footer-links">
                                <Link to="/" className="footer-link">Accueil</Link>
                                <Link to="/nos-formations" className="footer-link">Nos Formations</Link>
                                <Link to="https://www.cinef-bj.com/formations/nos-domaines/" className="footer-link">Nos Domaines</Link>
                                <Link to="/certifications-cinef" className="footer-link">Certifications</Link>
                                <Link to="https://www.cinef-bj.com/formations/docs/catalogue_cinef_2026.pdf" className="footer-link" target="_blank" rel="noopener noreferrer">Catalogue 2026</Link>
                            </div>
                        </div>

                        {/* Column 3 - Resources */}
                        <div className="footer-column">
                            <h3 className="footer-title">Ressources</h3>
                            <div className="footer-links">
                                <Link to="/a-propos" className="footer-link">À Propos</Link>
                                <Link to="/partenaires" className="footer-link">Nos Partenaires</Link>
                                <Link to="https://www.cinef-expertises.com/" className="footer-link" target="_blank" rel="noopener noreferrer">Conseils & Expertise</Link>
                                <Link to="/contact" className="footer-link">Contact</Link>
                            </div>
                        </div>

                        {/* Column 4 - Services */}
                        <div className="footer-column">
                            <h3 className="footer-title">Nos Services</h3>
                            <div className="footer-links">
                                <Link to="https://www.cinef-bj.com/recrutement/" className="footer-link" target="_blank" rel="noopener noreferrer">Recrutement</Link>
                                <Link to="https://cinef.app/" className="footer-link" target="_blank" rel="noopener noreferrer">Pole IT</Link>
                                <Link to="https://cinef-formations.trainercentralsite.com/#/allcourses" className="footer-link" target="_blank" rel="noopener noreferrer">E-learning</Link>
                                <Link to="/formations-distance" className="footer-link">Blended Learning</Link>
                                <Link to="/eval/:token" className="footer-link">Conseil en Gestion</Link>
                            </div>
                        </div>

                        {/* Column 5 - Contact */}
                        <div className="footer-column">
                            <h3 className="footer-title">Contact</h3>
                            <div className="footer-contact">
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div className="contact-content">
                                        <div className="contact-label">Email</div>
                                        <div className="contact-value">
                                            <a href="mailto:info@cinef-bj.com">info@cinef-bj.com</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon">
                                        <FaPhone />
                                    </div>
                                    <div className="contact-content">
                                        <div className="contact-label">Téléphone</div>
                                        <div className="contact-value">
                                            <a href="tel:+22963186060">+229 63 18 60 60</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Newsletter Section - Visible uniquement sur desktop et tablette */}
                    <div className="footer-newsletter-section">
                        <div className="footer-newsletter">
                            <div className="newsletter-content">
                                <h3 className="newsletter-title">Restez Informé</h3>
                                <p className="newsletter-text">
                                    Recevez nos dernières formations et offres exclusives directement dans votre boîte mail.
                                </p>
                            </div>
                            <div className="newsletter-form">
                                <div className="newsletter-form-inputs">
                                    <input
                                        type="email"
                                        placeholder="Votre adresse email"
                                        className="newsletter-input"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={isSubmitting}
                                    />
                                    <button
                                        type="button"
                                        className="newsletter-button"
                                        onClick={handleSubscribe}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <FaSpinner className="spinner" />
                                                <span>Envoi...</span>
                                            </>
                                        ) : (
                                            'S\'abonner'
                                        )}
                                    </button>
                                </div>
                                
                                {/* Message de succès */}
                                {success && (
                                    <div className="newsletter-message newsletter-success">
                                        <FaCheckCircle />
                                        <span>Inscription réussie ! Merci pour votre confiance.</span>
                                    </div>
                                )}

                                {/* Message d'erreur */}
                                {error && (
                                    <div className="newsletter-message newsletter-error">
                                        {error}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <div className="footer-bottom-content">
                            <div className="footer-copyright">
                                <div className="copyright-text">
                                    © 2025 CINEF. Tous droits réservés. Certificateur de compétences.
                                </div>
                                <div className="copyright-countries">
                                    BÉNIN · TOGO · GABON · CÔTE D'IVOIRE · MAROC · FRANCE
                                </div>
                            </div>
                            <div className="footer-legal">
                                <Link to="/mentions-legales" className="legal-link">Mentions Légales</Link>
                                <span className="legal-divider">·</span>
                                <Link to="/confidentialite" className="legal-link">Confidentialité</Link>
                                <span className="legal-divider">·</span>
                                <Link to="/cgv" className="legal-link">CGV</Link>
                                <span className="legal-divider">·</span>
                                <Link to="/cookies" className="legal-link">Cookies</Link>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default Footer;